<form [formGroup]="billingInformationForm">
  <h3>Billing information</h3>
  <app-shared-input
    [control]="billingInformationForm.controls['address']"
    label="Address"
    dataAutoId="address-input">
  </app-shared-input>

  <app-shared-input
    [control]="billingInformationForm.controls['address2']"
    label="Address Line 2"
    dataAutoId="address2-input">
  </app-shared-input>

  <div class="flex flex-row gap-2">
    <div class="w-6">
      <app-shared-input
        [control]="billingInformationForm.controls['city']"
        label="City"
        dataAutoId="city-input">
      </app-shared-input>
    </div>

    <div class="p-fieldset field w-6">
      <label id="stateLabel" class="font-medium">State</label>
      <div *ngIf="billingInformationForm.controls['state'].errors?.['required']" class="required">
        <span class="bg-slate-100">Required</span>
      </div>
      <div *ngIf="billingInformationForm.controls['state'].touched && billingInformationForm.controls['state'].errors?.['required']" class="required text-orange-900">
        <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
      </div>
      <p-select aria-labelledby="stateLabel" formControlName="state" class="flex w-full" [options]="states" placeholder="Select a State" [showClear]="true" data-auto-id="state-select"></p-select>
      <div *ngIf="billingInformationForm.controls['state'].touched">
        <small *ngIf="billingInformationForm.controls['state'].errors?.['required']" class="mt-1 text-rose-600">
          State is required.
        </small>
      </div>
    </div>
  </div>

  <app-shared-input
    [control]="billingInformationForm.controls['zipCode']"
    label="ZIP Code"
    dataAutoId="zip-code-input"
    [maxLength]="5">
  </app-shared-input>


</form>
